import { type InputHTMLAttributes, type TextareaHTMLAttributes, forwardRef, type WheelEvent } from 'react';
import { cn } from '@/lib/utils';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hint?: string;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, label, hint, error, type, onWheel, ...rest }, ref) => {
    // ✅ تعطيل زيادة/نقصان القيم بعجلة الماوس في خانات الأرقام
    // نزيل الـ focus عند الـ wheel → المتصفح ما يغيّرش القيمة
    // لكن الصفحة لسه بتسكرول عادي لو الـ input مش focused
    const handleWheel = (e: WheelEvent<HTMLInputElement>) => {
      if (type === 'number') {
        e.currentTarget.blur();
      }
      onWheel?.(e);
    };

    return (
      <div className="flex flex-col gap-1">
        {label && (
          <label className="text-xs font-semibold text-slate-600 dark:text-slate-400">{label}</label>
        )}
        <input
          ref={ref}
          type={type}
          onWheel={handleWheel}
          className={cn(
            'w-full px-4 py-2.5 rounded-xl border bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 focus:outline-none focus:ring-4 focus:ring-indigo-500/15 focus:border-indigo-500 transition-all',
            error
              ? 'border-rose-400 focus:ring-rose-500/15 focus:border-rose-500'
              : 'border-slate-300 dark:border-slate-600',
            className,
          )}
          {...rest}
        />
        {hint && !error && <p className="text-xs text-slate-500">{hint}</p>}
        {error && <p className="text-xs text-rose-600">{error}</p>}
      </div>
    );
  },
);
Input.displayName = 'Input';

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  hint?: string;
}
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, label, hint, ...rest }, ref) => {
    return (
      <div className="flex flex-col gap-1">
        {label && (
          <label className="text-xs font-semibold text-slate-600 dark:text-slate-400">{label}</label>
        )}
        <textarea
          ref={ref}
          className={cn(
            'w-full px-4 py-2.5 rounded-xl border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 focus:outline-none focus:ring-4 focus:ring-indigo-500/15 focus:border-indigo-500 transition-all',
            className,
          )}
          {...rest}
        />
        {hint && <p className="text-xs text-slate-500">{hint}</p>}
      </div>
    );
  },
);
Textarea.displayName = 'Textarea';
